import { DROP } from "components/common";
import { DROP_CONFIG } from "components/Drops/dropConfig";

export const getDropFromContractAddress = (address: string) => {
  if (DROP_CONFIG.genesis.contractAddress === address) {
    return DROP.genesis;
  }

  if (DROP_CONFIG.enigma.contractAddress === address) {
    return DROP.enigma;
  }

  if (DROP_CONFIG.futura.contractAddress === address) {
    return DROP.futura;
  }

  throw new Error('Unknown contract address');
};
